var React = require('react');

function IconChef (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0109863 0L2.00317 22.5L10.9485 25L19.8907 22.5016L21.886 0H0.0109863ZM17.6266 7.35781L17.375 10.1844L16.6172 18.6594L10.9485 20.225L10.9454 20.2266L5.2813 18.6578L4.88442 14.2266H7.65942L7.86567 16.5266L10.9454 17.3578L10.9485 17.3547L14.0313 16.5234L14.4516 12.6937L4.75161 12.7203L4.47661 10.1L14.6844 9.98125L14.8907 7.17656L4.20317 7.20625L4.02349 4.6H10.9485H17.8735L17.6266 7.35781Z","fill":"black"}));
}

IconChef.defaultProps = {"width":"22","height":"25","viewBox":"0 0 22 25","fill":"none"};

module.exports = IconChef;

IconChef.default = IconChef;
